<script lang="ts">
    import {leadZero, timeSince} from './utils/utils'
    export let time: number = 0
    export let locale: string = 'ru-RU'
    export let actual: boolean = true
    export let archive;

    const date = new Date(time*1000)

</script>
<span class:kurs-warning="{!actual}" >
    {#if archive==false}
        <time title={date.toLocaleString(locale)}>{leadZero(date.getHours())}:{leadZero(date.getMinutes())}:<i>{leadZero(date.getSeconds())}</i></time>    
        <br>
        {#if actual==false}
            <span class="relativeTime" data-tooltip="Возможно, курс уже неактуальный">{timeSince(date)}</span>   
            {:else}
            <span class="relativeTime">{timeSince(date)}</span>   
        {/if} 
    {:else}
        <time title={date.toLocaleString(locale)}>{date.toLocaleString(locale)}</time> 
    {/if}
</span>
<style>
.relativeTime {
    font-size: 10px;
    color: gray;
    font-style: italic;
    margin-top: 5px;
}
.kurs-warning .relativeTime {
    background: url(/img/icons/warning.svg) no-repeat 3px;
    background-size: 8px 8px;
    padding: 0 0 0 16px;
    font-size: 10px;
    margin: 3px 0;
    color: #d4aa00
}
time{
    font-size: 14px;
}
time i{
    font-weight: normal;
    font-style: normal;
    color:#a8a8a8
}
</style>